import { useEffect, useState } from 'react';
import axios from 'axios';
import config from '../../config';

import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import { toast } from 'react-toastify';

const EditWorkPermitForm = ({ row, property, units, propertyAccounts, onClose }) => {
  const [unitAccounts, setUnitAccounts] = useState([]);
  const [error, setError] = useState(null);
  const [formData, setFormData] = useState({ ...row });

  useEffect(() => {
    const fetchAccounts = async () => {
      try {
        const res = await axios.get(`${config.API_URL}/v2/role/unitRole/unit/${row.unit._id}`, {headers: {Authorization: `Bearer ${localStorage.getItem('accessToken')}`}});
        const accounts = res.data.map(r => r.propertyRole?.account || r.account);
        console.log("Fetched unit accounts:", accounts);
        setUnitAccounts(accounts);
      } catch (err) {
        console.error("Error loading unit accounts", err);
      }
    };
    fetchAccounts();
  }, [row.unit]);


  const handleSubmit = async () => {
  try {
    const updatedFormData = {
      ...formData,
      unit: formData.unit?._id,
      requestedBy: formData.requestedBy?._id,
      managedBy: formData.managedBy.map(m => m._id),
      assignees: formData.assignees?.map(a => a._id),
    };

    await axios.put(`${config.API_URL}/v2/request/${formData._id}`, updatedFormData, {
      headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}`, 'Content-Type': 'application/json' },
    });
    toast.success("Work Permit updated successfully!");
    onClose();
  } catch (err) {
    console.error("Update failed:", err.response?.data || err.message);
    setError("Error updating form.");
    toast.error("Failed to update Work Permit.");
  }
};


  return (
    <div className="popup-overlay">
      <div className="popup-content">
        <button className="close-popup" onClick={onClose}>
          <i className="fas fa-times"></i>
        </button>
        <h2 className="text-2xl text-black">Edit Work Permit</h2>

        <div className="popup-columns">
          <Autocomplete
            options={units.filter(u => u.property?._id === property.property._id)}
            getOptionLabel={(u) => u.unitNumber}
            value={formData.unit}
            onChange={(e, newVal) => setFormData(prev => ({ ...prev, unit: newVal?._id }))}
            renderInput={(params) => <TextField {...params} label="Unit" required />}
            sx={{ width: '100%', marginBottom: '1rem' }}
          />

          <Autocomplete
            options={["Pending", "Completed", "Rejected"]}
            value={formData.status}
            onChange={(e, val) => setFormData(prev => ({ ...prev, status: val }))}
            renderInput={(params) => <TextField {...params} label="Status" required />}
            sx={{ width: '100%', marginBottom: '1rem' }}
            />
        </div>


          <TextField
            label="Request Title"
            name="title"
            fullWidth
            value={formData.details.title}
            onChange={(event) => {
              const newValue = event.target.value;
              setFormData((prevData) => ({
                ...prevData,
                details: {
                  ...prevData.details,
                  title: newValue,
                },
              }));
            }}
            sx={{ marginBottom: '1rem' }}
            required
          />

        <Autocomplete
            options={unitAccounts}
            getOptionLabel={(acc) => `(${acc.type}) ${acc?.user?.email}`}
            value={formData.requestedBy}
            onChange={(e, newVal) => setFormData(prev => ({ ...prev, requestedBy: newVal?._id }))}
            renderInput={(params) => <TextField {...params} label="Filed By" required />}
            sx={{ width: '100%', marginBottom: '1rem' }}
          />

        <Autocomplete
          multiple
          options={unitAccounts.filter(a => a?.type === 'manager' || a?.type === 'staff')}
          getOptionLabel={(a) => {
            if (!a) return '';
            const email = a?.user?.email || 'Unknown';
            const type = a?.type || 'N/A';
            return `(${type}) ${email}`;
          }}
          isOptionEqualToValue={(option, value) => option._id === value._id}
          value={formData.managedBy || []}
          onChange={(e, newVal) =>
            setFormData((prev) => ({ ...prev, managedBy: newVal }))
          }
          renderInput={(params) => <TextField {...params} label="Managed By" />}
          sx={{ marginBottom: '1rem' }}
        />


        <TextField
          label="Service Provider"
          fullWidth
          value={formData.details.serviceProvider}
          onChange={(e) =>
            setFormData(prev => ({
              ...prev,
              details: { ...prev.details, serviceProvider: e.target.value },
            }))
          }
          sx={{ marginBottom: '1rem' }}
        />

        <Autocomplete
          options={["Wifi", "Plumbing", "Electrical", "Cleaning", "Renovation", "Painting"]}
          value={formData.details.workCategory}
          onChange={(event, newValue) => {
            if (newValue) {
              setFormData(prev => ({
                ...prev,
                details: { ...prev.details, workCategory: newValue },
              }));
            }
          }}
          renderInput={(params) => <TextField {...params} label="Work Category" required />}
          sx={{ marginBottom: '1rem' }}
        />

        <TextField
          label="Work Description"
          multiline
          fullWidth
          rows={3}
          value={formData.description}
          onChange={(e) => setFormData(prev => ({ ...prev, description: e.target.value }))}
          sx={{ marginBottom: '1rem' }}
        />

        <div className="popup-columns">
          <TextField
            type="date"
            label="Start Date"
            fullWidth
            InputLabelProps={{ shrink: true }}
            value={formData.details.startDate}
            onChange={(e) =>
              setFormData(prev => ({
                ...prev,
                details: { ...prev.details, startDate: e.target.value },
              }))
            }
            sx={{ marginBottom: '1rem' }}
          />
          <TextField
            type="date"
            label="End Date"
            fullWidth
            InputLabelProps={{ shrink: true }}
            value={formData.details.endDate}
            onChange={(e) =>
              setFormData(prev => ({
                ...prev,
                details: { ...prev.details, endDate: e.target.value },
              }))
            }
            sx={{ marginBottom: '1rem' }}
          />
        </div>

        <button className="button" onClick={handleSubmit}>Save Changes</button>
        {error && <div className="error-message">{error}</div>}
      </div>
    </div>
  );
};

export default EditWorkPermitForm;
